import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import DialogModal from '../../common/DialogModal';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '66.67%',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
    textAlign: 'left',
  },

  container: {
    width: '100%',
    background: '#FFFFFF',
    border: '1px solid #E7E9EB',
  },

  img: {
    width: '100%',
  },

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '50px 0px',
  },

  titleHeading: {
    fontSize: '24px',
    marginBottom: '10px',
  },

  titleDesc: {
    fontSize: '16px',
    textAlign: 'center',
  },

  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: '0px 54px'
  },
});

const boxStyles = () => ({
  box: {
    width: 'calc(50% - 24px)',
    marginBottom: '42px',
  },

  contentHeading: {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '22px 0px 18px 0px',
  },

  contentDesc: {
    fontSize: '16px',
    lineHeight: '28px',
  },

  contentImgContainer: {
    background: '#FAFAFA',
    border: '1px solid #E7E9EB',
    width: '100%',
    display: 'flex',
  },

  img: {
    width: '100%',
  },
});

const Box = withStyles(boxStyles)(({ classes, fileName, title, desc }) => (
  <div className={classes.box}>
    <div className={classes.contentImgContainer}>
      <img
        alt={fileName}
        src={require(`../../../assets/images/${fileName}`)}
        className={classes.img}
      />
    </div>

    <Typography variant="title" className={classes.contentHeading}>
      {title}
    </Typography>
    <Typography variant="body2" className={classes.contentDesc}>
      {desc}
    </Typography>
  </div>
))


class InfoDialog extends React.Component {
  render() {
    const { classes, toggleDialog, isOpen } = this.props;

    return (
      <DialogModal
        title="送付物の構成・紙質について"
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.container}>
          <img
            alt="send-letter-info-img1"
            src={require('../../../assets/images/send-letter-info-img1@2x.png')}
            className={classes.img}
          />
          <div className={classes.titleContainer}>
            <Typography variant="display1" className={classes.titleHeading}>成果につながるレターの構成</Typography>
            <Typography variant="subheading" className={classes.titleDesc}>
              Keyman Letterのセールスチームが実際に送付し、<br />
              高い成果をあげているレターの構成をご利用ください
            </Typography>
          </div>
          <div className={classes.content}>
            <Box
              fileName="send-letter-info-img2@2x.png"
              title="レターの定番・長3封筒 + A4三つ折り"
              desc="長3号封筒にA4用紙を三つ折りにして封入し、ベロは糊付けして封緘します。Keyman Letterのセールスチームのノウハウを余すことなく反映しています。"
            />

            <Box
              fileName="send-letter-info-img3@2x.png"
              title="特別感のある高級和紙を使用"
              desc="特別感を出すため、大礼紙と呼ばれる高級和紙を使用します。紙質にご指定がある場合はお問い合わせください。"
            />

            <Box
              fileName="send-letter-info-img4@2x.png"
              title="切手は手作業で貼り付け"
              desc="人の手によって送られたレターの感じを出すため、別納・後納マークなどのプリンタによる印字は避け、手作業で切手を貼り付けます。"
            />

            <Box
              fileName="send-letter-info-img5@2x.png"
              title="職人による宛名・差出人レイアウト"
              desc="宛名・差出人のレイアウトは、挨拶状などの宛名組版に長けたDTPオペレーターが手作業でレイアウトします。文字の長さに合わせて、フォントサイズ、行間をバランスよく調整します。"
            />
          </div>
        </div>
      </DialogModal>
    );
  }
}

InfoDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default withStyles(styles)(InfoDialog);



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/InfoDialog.jsx